module.exports = __webpack_public_path__ + "img/settings-10-blue.7e476013.svg";